export function uploadAttachmentWithProgress(
  uploadUrl: string,
  file: File,
  contentType: string,
  reportProgressPercent: (progressPercent: number) => void
): Promise<void> {
  return new Promise(function runUpload(resolveUpload, rejectUpload) {
    const uploadRequest = new XMLHttpRequest();
    uploadRequest.open('PUT', uploadUrl);
    uploadRequest.setRequestHeader('Content-Type', contentType);
    uploadRequest.upload.addEventListener('progress', function handleProgress(progressEvent) {
      if (progressEvent.lengthComputable === true && progressEvent.total > 0) {
        const percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
        reportProgressPercent(percent);
      }
    });
    uploadRequest.addEventListener('load', function handleLoad() {
      if (uploadRequest.status >= 200 && uploadRequest.status < 300) {
        reportProgressPercent(100);
        resolveUpload();
      } else {
        rejectUpload(new Error('File upload to storage failed with status ' + uploadRequest.status));
      }
    });
    uploadRequest.addEventListener('error', function handleError() {
      rejectUpload(new Error('File upload to storage failed'));
    });
    uploadRequest.addEventListener('abort', function handleAbort() {
      rejectUpload(new Error('File upload to storage was aborted'));
    });
    uploadRequest.send(file);
  });
}
